module.exports = __webpack_public_path__ + "img/building.925a65c7.svg";